import { connect } from 'react-redux';

import { getAllApps } from '../../../../ducks/pages/admin_apps/thunks';

const connector = connect(null, {
  getAllApps,
});

export default connector;
